module.exports = __webpack_public_path__ + "static/media/sb-one-info.a652905a.svg";